module.exports = __webpack_public_path__ + "static/media/picnicker-gold-yeti.bb4594df.png";